import React from "react";
import HeroCard from "./HeroCard";
import { getDomain } from "@/theme/domains";

// Re-export gradient map for legacy references (prefer getDomain().gradient going forward)
export const DOMAIN_GRADIENTS = {
  district:  "from-[#0b3b82] via-[#1b4f9c] to-[#2563eb]",
  flock:     "from-[#064e3b] via-[#065f46] to-[#059669]",
  church:    "from-[#0b1e40] via-[#162d5e] to-[#1b3d7a]",
  agenda:    "from-[#1e1b4b] via-[#3730a3] to-[#4f46e5]",
  resources: "from-[#134e4a] via-[#0f766e] to-[#0d9488]",
  admin:     "from-[#0f172a] via-[#1e293b] to-[#334155]",
};

export default function DomainHero({
  domain = "district",
  title,
  titleClassName,
  subtitle,
  icon,
  actions,
  stats,
  children,
  onLocationClick,
  variant = "compact",
  className,
}) {
  return (
    <HeroCard
      gradient={getDomain(domain).gradient}
      title={title}
      titleClassName={titleClassName}
      subtitle={subtitle}
      icon={icon}
      actions={actions}
      stats={stats}
      onLocationClick={onLocationClick}
      variant={variant}
      className={className}
    >
      {children}
    </HeroCard>
  );
}
